import { SimplifiedStepSection } from '@quicktools/shared-components';
import { Button } from '@quicktools/shared-components/components/core/Button/Button';
import { IStep } from '@quicktools/shared-components/components/landingPages/SimplifiedStepSection';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

function HowToSection() {
  const { t } = useTranslation();

  const steps: IStep[] = Array.from(Array(3)).map((_, index) => ({
    title: t(`landing.howToSection.steps.${index}.title`),
    description: t(`landing.howToSection.steps.${index}.description`),
  }));

  const scrollToTop = useCallback(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <SimplifiedStepSection
      cta={<Button onClick={scrollToTop}>{t('landing.howToSection.cta')}</Button>}
      title={t('landing.howToSection.title')}
      steps={steps}
    />
  );
}

export default HowToSection;
